import '../css/index.scss';
import * as bootstrap from 'bootstrap';
import Lightbox from 'bs5-lightbox';
import AOS from 'aos';
import 'aos/dist/aos.css';
import * as core from './app/core';

document.querySelectorAll('[data-lightbox]').forEach(el => el.addEventListener('click', Lightbox.initialize));

/* AOS init */
AOS.init({
  easing: 'ease-out-back',
  duration: 800,
});

/*** startup functions ***/
core.startUp();

/* SCROLL PROGRESS */

const scrollProgress = document.getElementById('scroll-progress');
if (scrollProgress) {
  const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;

  window.addEventListener('scroll', () => {
    const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
    scrollProgress.style.width = `${(scrollTop / height) * 100}%`;
  });
}
console.log('CIGAR.AGENCY scripts loaded...');
